import css from 'styled-jsx/css';
import { colors } from '../../theme/theme';

const style = css`
  .fuel-transaction-items {
    padding: 16px 24px 100px;
    background: ${colors.white};
  }
  .total-row {
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
    gap: 16px;
    padding: 12px 8px 0;
    font-size: 15px;
    font-weight: 500;
  }
  .total-label {
    color: rgba(0, 0, 0, 0.65);
    font-size: 12px;
  }
`;

export default style;
